import React, { Component } from 'react'
import { get } from '../../utils/networking'
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";

export default class Offer extends Component {
    constructor(props) {
        super(props)

        this.slug = this.props.match.params.slug

        this.state = {
            offers: []
        }

    }

    componentWillMount() {
        get('coupon/getSpecialOffers', "", result => {
            this.setState({
                offers: result
            })
        })
    }

    render() {

        const offers = this.state.offers

        return (
            <div>
                <main>
                    <div className="border_line_bottom page_offer">
                        <div className="deals-header">
                            <p className="deals-header-p">Nail spa of america Wellness 365™</p>
                            <h1>
                                <img src="/assets/images/deal-head-tag.png" className="deal-header-img" />
                                Special Offers
                            </h1>
                            <p>The best exclusive deals and offers for massage, spa packages, travel, and last minute getaways.</p>
                        </div>
                        <div className="container">
                            <div className="content clearfix">
                                <div className="content_main clearfix">
                                    <fieldset>
                                        <legend>SPECIAL OFFERS</legend>
                                        <div className="clearfix">
                                            <div className="row clearfix">
                                                {offers.map((offer, i) =>
                                                    <div key={i} className="col_4 col_sm_12">
                                                        <div className="row_col">
                                                            <div className="img">
                                                                <img src={offer.photo} alt="" />
                                                            </div>
                                                            <h3 className="title"><span>{offer.title}</span></h3>
                                                            <div className="deal-item-content">
                                                                <div className="row_col">
                                                                    <p>{offer.synopsis}</p>
                                                                    <p><NavLink to={"/spa/" + offer.spaSlug}>View Details</NavLink></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/offer/index.js